import { useState, type PointerEvent } from 'react'
import { globalDefectNumber } from '../utils/defectMarks'

export type ListingDetailDefectPin = {
  x: number
  y: number
  label: string
  photo_index?: number
  displayIndex?: number
}

type Props = {
  pins: ListingDetailDefectPin[]
  allMarks: ListingDetailDefectPin[]
  popoverClassName?: string
}

function pinKey(m: ListingDetailDefectPin, localIdx: number) {
  return `${m.x}-${m.y}-${localIdx}`
}

export function isListingDefectPinTarget(target: EventTarget | null) {
  return target instanceof HTMLElement && !!target.closest('.listing-detail-defect-pin-wrap')
}

export default function ListingDetailDefectPins({ pins, allMarks, popoverClassName = '' }: Props) {
  const [openKey, setOpenKey] = useState<string | null>(null)

  if (pins.length === 0) return null

  function onPinPointerDown(e: PointerEvent<HTMLElement>) {
    e.stopPropagation()
  }

  return (
    <>
      {pins.map((m, i) => {
        const key = pinKey(m, i)
        const open = openKey === key
        const num = globalDefectNumber(allMarks, m)
        return (
          <div
            key={`defect-${key}`}
            className={`listing-detail-defect-pin-wrap${open ? ' listing-detail-defect-pin-wrap--open' : ''}`}
            style={{ left: `${m.x}%`, top: `${m.y}%` }}
          >
            <button
              type="button"
              className="listing-detail-defect-pin"
              aria-expanded={open}
              aria-label={m.label}
              onPointerDown={onPinPointerDown}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setOpenKey((prev) => (prev === key ? null : key))
              }}
            >
              {num}
            </button>
            {open ? (
              <div
                className={`listing-detail-defect-popover${popoverClassName ? ` ${popoverClassName}` : ''}`}
                role="tooltip"
              >
                {m.label}
              </div>
            ) : null}
          </div>
        )
      })}
    </>
  )
}
